<template>
  <div>
    <ProductSubCategoryPage
      v-if="subcategories.includes(route.params.slug)"
    ></ProductSubCategoryPage>
    <ProductDetailPage v-else param_name="slug"></ProductDetailPage>
  </div>
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();
const route = useRoute();

const subcategories = globalStore.siteSettings.subcategories;
</script>
